import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PasswordsActions from './password.actions';
import { Store } from '@ngrx/store';
import { catchError, concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';

import { getAuth } from '../auth/auth.selectors';
import { PasswordsResponse } from './../../../app/@shared/models/passwords_response.model';

@Injectable()
export class PasswordsEffects {
  constructor(private readonly actions$: Actions, private readonly store: Store, private readonly apiPublic: PublicPartnerApiService) { }

  loadPasswords$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PasswordsActions.loadPasswords),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.get<Partial<PasswordsResponse>>('/users/' + auth!.user_uuid + '/auths/passwords', {}).pipe(
            filter(result => result?.passwords !== undefined),
            map(result => {
              return PasswordsActions.loadPasswordsSuccess({
                passwords: result.passwords!
              });
            }),
            catchError(error => of(PasswordsActions.loadPasswordsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  patchPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PasswordsActions.patchPassword),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.patch<{ object_uuid: string; }>('/users/' + auth!.user_uuid + '/auths/passwords/' + action.uuid, action.data).pipe(
            map((result) => {
              return PasswordsActions.patchPasswordSuccess({
                data: result
              });
            }),
            catchError(error => of(PasswordsActions.patchPasswordFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );
}
